import React__default from 'react';
import { layoutPropTypes } from './Sidebar.types.js';

var Layout = function (_a) {
    var children = _a.children, headerComponent = _a.headerComponent, footerComponent = _a.footerComponent, headerClassName = _a.headerClassName, bodyClassName = _a.bodyClassName, footerClassName = _a.footerClassName, className = _a.className, testId = _a["data-testid"], bodyContainerRef = _a.bodyContainerRef, zIndex = _a.zIndex, handleOnTransitionEnd = _a.handleOnTransitionEnd;
    return (React__default.createElement("div", { className: className, onTransitionEnd: handleOnTransitionEnd, "data-testid": testId, style: { zIndex: zIndex } },
        React__default.createElement("div", { className: headerClassName }, headerComponent),
        React__default.createElement("div", { className: bodyClassName, ref: bodyContainerRef }, children),
        React__default.createElement("div", { className: footerClassName }, footerComponent)));
};
Layout.propTypes = layoutPropTypes;
Layout.displayName = 'Sidebar.Layout';

export { Layout, Layout as default };
